import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'

class FileService {
  // get all brokers a user belongs to
  async getFilesFromAzure({
    identifier,
    type,
  }: {
    identifier: string
    type: string
  }): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.file.getFilesFromAzure}?identifier=${identifier}&type=${type}`

    return ApiProvider.getRequest(url) as Promise<any | (AxiosError | Error)>
  }

  async addFilesToAzure(
    identifier: string,
    type: string,
    file: File,
  ): Promise<any | (AxiosError | Error)> {
    const formData = new FormData()
    formData.append('identifier', identifier)
    formData.append('type', type)
    formData.append('file', file)

    return ApiProvider.postRequest(
      APIRoutes.file.addFilesToAzure,
      formData,
      true,
    ) as Promise<any | (AxiosError | Error)>
  }

  async deleteFileFromAzure(
    identifier: string,
    type: string,
  ): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.file.deleteFileFromAzure}?identifier=${identifier}&type=${type}`

    return ApiProvider.deleteRequest(url) as Promise<any | (AxiosError | Error)>
  }
}

export const fileService = new FileService()
